import { render, staticRenderFns } from "./AssetFgasAdd.vue?vue&type=template&id=38f0541e&"
import script from "./AssetFgasAdd.vue?vue&type=script&lang=js&"
export * from "./AssetFgasAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports